// The pricing app owns this table. Keep absent specifications explicit without changing prices.
(() => {
  function init() {
    const table = document.getElementById('diamond-table');
    if (!table || table.dataset.urauraChecked) return;
    table.dataset.urauraChecked = 'true';
    const clean = () => {
      table.querySelectorAll('td').forEach(cell => {
        if (/^(undefined|null)$/i.test(cell.textContent.trim())) cell.textContent = 'Contact us';
      });
    };
    clean();
    new MutationObserver(clean).observe(table, {childList: true, subtree: true, characterData: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
